import React, { createContext, useContext, useState, useEffect } from 'react';

import { API_BASE_URL as API_URL } from '../utils/apiConfig';

const BrandContext = createContext();

export function useBrand() {
  return useContext(BrandContext);
}

export function BrandProvider({ children }) {
  const [brand, setBrand] = useState(null);
  const [subdomain, setSubdomain] = useState(null);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Detect subdomain from URL
    const hostname = window.location.hostname;
    let detectedSubdomain = null;
    
    // Parse subdomain (e.g., newuAI.fundledata.com -> newu)
    if (hostname.includes('.fundledata.com')) {
      const parts = hostname.split('.');
      if (parts.length >= 3) {
        detectedSubdomain = parts[0].toLowerCase().replace('ai', '');
      }
    } else if (hostname.includes('localhost') || hostname.includes('preview.emergentagent.com')) {
      // Development mode - check URL params or default to fundlebrain
      const params = new URLSearchParams(window.location.search);
      detectedSubdomain = params.get('brand') || 'fundlebrain';
    }
    
    // Special case: fundlebrain is the super admin portal
    if (detectedSubdomain === 'fundlebrain' || !detectedSubdomain) {
      setIsSuperAdmin(true);
      setSubdomain('fundlebrain');
    } else {
      setSubdomain(detectedSubdomain);
    }
    
    setLoading(false);
  }, []);

  const fetchBrandInfo = async (brandSubdomain) => {
    try {
      const response = await fetch(`${API_URL}/api/brands?subdomain=${brandSubdomain}`);
      if (response.ok) {
        const data = await response.json();
        if (data.brands && data.brands.length > 0) {
          setBrand(data.brands[0]);
        }
      }
    } catch (error) {
      console.error('Failed to fetch brand info:', error);
    }
  };

  const switchBrand = (newBrand) => {
    setBrand(newBrand);
  };

  const value = {
    brand,
    setBrand,
    subdomain,
    isSuperAdmin,
    loading,
    switchBrand,
    fetchBrandInfo
  };

  return (
    <BrandContext.Provider value={value}>
      {children}
    </BrandContext.Provider>
  );
}
